import { useTranslation } from "react-i18next";

// Importando os componentes
import FixedTable from "../../../Layout/Components/Table/FixedTable";
import Loading from "../../../Layout/Components/Loading";
import { useAccountReceivable } from "../../../../Hook/Financial/useAccountReceivable";
import AccountReceivableInfo from "./account_receivable_info";
import AccountReceivableMenu from "./account_receivable_menu";

export default function AccountReceivable({ idClient }) {
    const { t } = useTranslation();
    const {
        accountReceivable,
        loading,
        totalsValue,
        reload,
        search,
        setSearch,
    } = useAccountReceivable({ idClient });

    // Definindo as colunas da tabela
    const tableColumns = [
        {
            field: "id",
            label: "#",
            type: "number",
        },
        {
            field: "description",
            label: t("financial.accounts-receivable.table.description"),
            type: "string",
        },
        {
            field: "game.description",
            label: t("financial.accounts-receivable.table.game"),
            type: "string",
        },
        {
            field: "payment_type",
            value: {
                1: t("financial.accounts-receivable.table.type-price.time"),
                2: t("financial.accounts-receivable.table.type-price.line"),
            },
            label: t("financial.accounts-receivable.table.type-price.label"),
            type: "string",
        },
        {
            field: "create_at",
            label: t("financial.accounts-receivable.table.issue_date"),
            type: "date-time",
        },
        {
            field: "quantity",
            label: t("financial.accounts-receivable.table.quantity"),
            type: "string",
        },
        {
            field: "unit_value",
            label: t("financial.accounts-receivable.table.unit_value"),
            type: "currency",
        },
        {
            field: "discount_value",
            label: t("financial.accounts-receivable.table.discount"),
            type: "currency",
        },
        {
            field: "total_value",
            label: t("financial.accounts-receivable.table.total_value"),
            type: "currency",
        },
        {
            field: "payment_status",
            value: {
                1: t("financial.accounts-receivable.table.status.paid"),
                2: t("financial.accounts-receivable.table.status.pending"),
                3: t("financial.accounts-receivable.table.status.cancelled"),
            },
            label: t("financial.accounts-receivable.table.status.label"),
            type: "string",
            style: (row) => {
                return {
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    color:
                        row.payment_status === 1
                            ? "#00B74A"
                            : row.payment_status === 2
                            ? "#FFA900"
                            : "#F93154",
                };
            },
        },
        {
            field: "payment_date",
            label: t("financial.accounts-receivable.table.payment_date"),
            type: "date-time",
        },
        {
            field: "create_user.name",
            label: t("financial.accounts-receivable.table.create_user"),
            type: "string",
        },
        {
            field: "cancelled_at",
            label: t("financial.accounts-receivable.table.cancelled_date"),
            type: "date-time",
        },
        {
            field: "cancelled_user.name",
            label: t("financial.accounts-receivable.table.cancelled_user"),
            type: "string",
        },
        {
            field: "update_at",
            label: t("financial.accounts-receivable.table.update_at"),
            type: "date-time",
        },
        {
            field: "update_user.name",
            label: t("financial.accounts-receivable.table.update_user"),
            type: "string",
        },
    ];

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <AccountReceivableMenu
                        idClient={idClient}
                        search={search}
                        setSearch={setSearch}
                        reload={reload}
                    />
                    <AccountReceivableInfo totalValues={totalsValue} />
                    <FixedTable
                        table="clients_account_receivable"
                        columns={tableColumns}
                        data={accountReceivable}
                        empty={t("financial.accounts-receivable.table.empty")}
                        reload={reload}
                    />
                </>
            )}
        </>
    );
}
